module.exports = __webpack_public_path__ + "static/media/login-banner.ae09ea05.jpg";